document.documentElement.classList.add('js');
document.documentElement.classList.remove('no-js');

require('window.requestanimationframe');
require('jquery-debounce-throttle');
window.slickCarousel = require('slick-carousel');
require('focus-visible');
window.objectFitImages = require('object-fit-images');
global.bsCustomFileInput = require('bs-custom-file-input');
global.vhCheck = require('vh-check');
global.svg4everybody = require('svg4everybody');

require('./app/components/_components.header.js');
require('./app/components/_components.burger.js');
require('./app/components/_components.navigation.js');
require('./app/components/_components.toggler.js');
require('./app/components/_components.formula.js');
require('./app/objects/_objects.cards-slider.js');
require('./app/objects/_objects.carousel.js');
require('./app/objects/_objects.quicklinks.js');
require('./app/utilities/_utilities.object-fit.js');
require('./app/utilities/_utilities.file-input.js');
require('./app/utilities/_utilities.vh-check.js');
require('./app/utilities/_utilities.tooltip.js');
require('./app/bootstrap/tooltip.js');
require('./app/bootstrap/alert.js');
require('./app/bootstrap/button.js');
require('./app/bootstrap/carousel.js');
require('./app/bootstrap/collapse.js');
//require('./app/bootstrap/dropdown.js');
require('./app/bootstrap/index.js');
require('./app/bootstrap/modal.js');
require('./app/bootstrap/popover.js');
require('./app/bootstrap/scrollspy.js');
require('./app/bootstrap/tab.js');
require('./app/bootstrap/toast.js');
require('./app/bootstrap/util.js');
